import { motion } from 'framer-motion';
import AnimatedSection, { staggerContainer, fadeUpVariant } from './AnimatedSection';
import './HowItWorks.scss';

const steps = [
  {
    num: '01',
    title: 'Submit Shipment',
    desc: 'Traders and brokers submit a shipment request. We review the corridor, counterparties, and execution plan.',
    tag: 'Request & Review',
    active: false,
  },
  {
    num: '02',
    title: 'Finance & Monitor',
    desc: 'OneLedger deploys capital per shipment, tracks execution in real time, and manages counterparty risk end-to-end.',
    tag: 'Capital Deployment',
    active: true,
  },
  {
    num: '03',
    title: 'Settle on Delivery',
    desc: 'Payment is triggered on confirmed delivery. All parties receive their settlement promptly and transparently.',
    tag: 'Reliable Settlement',
    active: false,
  },
];

export default function HowItWorks({ compact = false }) {
  return (
    <section className="how-it-works">
      <div className="container">
        {!compact && (
          <AnimatedSection className="how-it-works__header">
            <p className="how-it-works__label">The Process</p>
            <h2 className="how-it-works__title">Three steps to funded, executed trade</h2>
          </AnimatedSection>
        )}

        <div className="how-it-works__steps">
          <div className="how-it-works__line" aria-hidden>
            <motion.div
              className="how-it-works__line-fill"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.5 }}
            />
          </div>

          <motion.div
            className="how-it-works__steps-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {steps.map(({ num, title, desc, tag, active }) => (
              <motion.div key={num} className="how-it-works__step" variants={fadeUpVariant}>
                <div className={`how-it-works__num${active ? ' how-it-works__num--active' : ''}`}>
                  {num}
                </div>
                <h3 className="how-it-works__step-title">{title}</h3>
                <p className="how-it-works__step-desc">{desc}</p>
                <span className="how-it-works__tag">{tag}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
